import * as React from "react";
import { LineCardTabs } from "./LineCardTabs";
import { LineOrderPanel } from "./LineOrderPanel";
import type { LineSummary, MachineDetail } from "@/types/lines.types";

export function LineCardExpanded({
  line,
  onMachineClick,
}: {
  line: LineSummary;
  onMachineClick: (m: MachineDetail) => void;
}): React.ReactElement {
  return (
    <div className="border-t border-border-subtle bg-bg-sunken px-[22px] pb-5 pt-6">
      <div className="grid gap-7 lg:[grid-template-columns:1.4fr_1fr]">
        <div>
          <LineCardTabs line={line} onMachineClick={onMachineClick} />
        </div>
        <div>
          <LineOrderPanel line={line} />
        </div>
      </div>
    </div>
  );
}
